<div class="appLoaderContainer" *ngIf="loading">
    <div class="appLoader">
        <img class = "loaderImg" src="assets/images/Infinity-1.8s-200px.svg" alt="">
    </div>
</div>

<div *ngIf="!loading" class="heading">Dashboard</div>

<div class="flex-btw cover" style="align-items: flex-start;" *ngIf="!loading">

    <div class="left-section">
        <div class="top">
        
            <div class="flex-el">
                <!-- <div>From: </div>
                &nbsp;
                <div style="width: 180px;">
                    <mat-form-field floatLabel="never"
                    class="custom-form-field" appearance="outline">
                        <input matInput autocomplete="on"
                        [matDatepicker]="pickers"
                        placeholder="mm/dd/yyyy">
                        <mat-datepicker-toggle matSuffix [for]="pickers"></mat-datepicker-toggle>
                        <mat-datepicker #pickers></mat-datepicker>
                    </mat-form-field>
                </div>
                &nbsp;
                &nbsp;
                <div> To: </div>
                &nbsp;
                <div style="width: 180px;">
                    <mat-form-field floatLabel="never"
                    class="custom-form-field" appearance="outline">
                        <input matInput autocomplete="on"
                        [matDatepicker]="pickerto"
                        placeholder="mm/dd/yyyy">
                        <mat-datepicker-toggle matSuffix [for]="pickerto"></mat-datepicker-toggle>
                        <mat-datepicker #pickerto></mat-datepicker>
                    </mat-form-field>
                </div>
                &nbsp;
                &nbsp; -->
                <!-- <div>
                    <button mat-icon-button color="primary" [matMenuTriggerFor]="notification">
                        <mat-icon matBadge="2" matBadgeColor="warn">notifications</mat-icon>
                    </button>
                </div> -->

                <mat-menu #notification="matMenu">
                    <div class="notification-header-section">
                        <div class="flex-el">
                          <h3>Notifications</h3>
                        </div>
                        <div style="color: #eee;font-size: smaller;position: relative;top: -10px;">
                          Stay updated with everything going on here
                        </div>
                      </div>
              
                      <div class="notification-wrapper">
                        <div class="notification">
                          <div class="flex-btw">
                            <div class="flex-el">
                              <!-- <div class="indicator"></div> &nbsp; -->
                              <div class="small-text bold-600">USER MANAGEMENT</div>
                            </div>
                            <div>
                              <div class="small-text bold-200">9:30AM</div>
                            </div>
                          </div>
              
                          <div class="notify-text">
                            A new user has been successfully added, kindly be notified
                          </div>
              
                          <div class="flex-end">
                            <button mat-button color="warn" class="notify-button">
                              Dismiss
                            </button>
                          </div>
                        </div>
              
                        <div class="notification">
                          <div class="flex-btw">
                            <div class="flex-el">
                              <!-- <div class="indicator"></div> &nbsp; -->
                              <div class="small-text bold-600">RECORD</div>
                            </div>
                            <div>
                              <div class="small-text bold-200">13/04/20</div>
                            </div>
                          </div>
              
                          <div class="notify-text">
                            An update has been made to the records listed <a href="">Check it out.</a>
                          </div>
              
                          <div class="flex-end">
                            <button mat-button color="warn" class="notify-button">
                              Dismiss
                            </button>
                          </div>
                        </div>
                      </div>
                </mat-menu>
            </div>
        </div>

        
        <div class="flex-btw mt-2 cover-card">
            <div class="info-card">
                <div class="topic">Total Number of Records</div>
                &nbsp;
                <div class="flex-btw">
                    <div class="amount">{{allLists.length | number}}</div>

                    <div class="icon">
                        <mat-icon fontSet="material-icons-outlined">inventory</mat-icon>
                    </div>
                </div>

                <div><mat-icon color="primary" style="top: 7px; position: relative;">visibility</mat-icon>&nbsp;{{watchList.length}} in Watch List</div>
            </div>

            <div class="info-card" >
                <div class="topic">Number of Individual Records</div>
                &nbsp;
                <div class="flex-btw">
                    <div class="amount">{{personalList.length | number}}</div>

                    <div class="icon">
                        <mat-icon >person_outline</mat-icon>
                    </div>
                </div>

                <div><mat-icon color="primary" style="top: 7px; position: relative;">visibility</mat-icon>&nbsp; {{individualwatchList.length}} in Watch List</div>
            </div>

            <div class="info-card">
                <div class="topic">Number of Organization Records</div>
                &nbsp;
                <div class="flex-btw">
                    <div class="amount">{{companyList.length | number}}</div>

                    <div class="icon">
                        <mat-icon fontSet="material-icons-outlined">business</mat-icon>
                    </div>
                </div>

                <div><mat-icon color="primary" style="top: 7px; position: relative;">visibility</mat-icon>&nbsp;{{companywatchList.length}} in Watch List</div>
            </div>
        </div>

        <div class="graph-card mt-2" [ngClass]="{'hideElement':permission?.isadd == 0 || permission2?.isadd == 0}">
            <div class="flex-el button-cover" style="justify-content: space-around; margin: 20px 0;">
                <div class="button-link">
                    <button mat-stroked-button type = 'button' class="but" routerLink="/app/records/add-individual">
                        <mat-icon style="font-size: 20px; position: relative; top: 1px;">add</mat-icon>
                        <div style="color: white;">
                            Add New Individual Record
                        </div>
                    </button>
                </div>
          
                <div class="button-link">
                    <button mat-stroked-button type = 'button' class="but"  routerLink="/app/records/add-company">
                        <mat-icon style="font-size: 20px; position: relative; top: 1px;">add</mat-icon>
                        <div style="color: white;">
                            Add New Organizational Record
                        </div>
                    </button> 
                </div>
            </div>
        </div>

        <div class="bottom-card flex-btw mt-2" style="align-items: flex-start;">
            <div class="two" style="min-height: 25vh;">
                <div class="head">Recently Added POI's</div>

                <div class="appLoaderContainer" *ngIf="loading">
                    <div class="appLoader">
                        <img class = "loaderImg" src="assets/images/Infinity-1.8s-200px.svg" alt="">
                    </div>
                </div>

                <div  class = "image" *ngIf="list.length == 0">
                    <img class = "img" src="assets/images/No data-amico.svg" alt="No data">
                    <p style="margin-top: 10px;">
                        No POI has been added.
                    </p>
                </div>
                <div class="wrapper custom-scroll-bar" style="overflow: auto;">
                    <div *ngFor="let item of list; let i = index" style="min-width: 50em;">
                        <div class="flex-btw list">
                            <div class="num" style="width: 10%;">{{i + 1}}.</div>
                            
                            <div class="name" style="width: 30%;" (click)="viewData(item)">{{item.name}}</div>

                            <div class="record" style="width: 15%;">On Watchlist: {{item.watchlist}}</div>

                            <div class="record" style="width: 20%;">{{item.type}}</div>
        
                            <div class="times" style="width: 20%;">{{getDateFormat(item.lastmodified)}}</div>
                        </div>
                        <mat-divider></mat-divider>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="right-section mt-3">
        <!-- <div class="frequent">
            <div class="head">Recent Activities</div>

            <div class="list custom-scroll-bar" style="height: 37vh;">
                <div  class = "image" >
                    <img class = "img" src="assets/images/No data-amico.svg" alt="No data">
                    <p style="margin-top: 10px;">
                        No Recent Activity.
                    </p>
                </div>
                
                <div class="flex-el note" style="align-items: flex-start;">
                    <div><mat-icon color="primary">event_note</mat-icon></div>
                    &nbsp;
                    &nbsp;
                    <div>Admin <b><i>Mubeen Abdulhameed</i></b> added a new note to the record for the Individual <b><i>James Iniobong</i></b>. <br> <span class="note-time">15 mins ago</span></div>
                </div>
                <mat-divider></mat-divider>
            </div>
        </div> -->

        <div class="recent">
            <div class="head">Watch List</div>

            <div class="list custom-scroll-bar" style="max-height: calc(100vh - 141px);">
                <div  class = "image"  *ngIf="watchList.length === 0">
                    <img class = "img" src="assets/images/No data-amico.svg" alt="No data">
                    <p style="margin-top: 10px;">
                        No record has been added to the watch list.
                    </p>
                </div>

                <div class="note" *ngFor="let watch of watchList">
                    <div class="flex-el"  style="align-items: flex-start;">
                        <div><mat-icon color="primary">visibility</mat-icon></div>
                        &nbsp;
                        <div style="width: 60%;">
                            <div class="name" (click)="viewData(watch)">{{watch.name}}</div>
                            <div class="record">{{watch.type}}</div>
                        </div>

                        <div class="times">{{getDateFormat(watch.lastmodified)}}</div>
                    </div>
                    <mat-divider></mat-divider>
                </div>
            </div>
        </div>
    </div>
</div>